import {
  baseGlobalStyle,
  createTheme,
  ModalBackdrop,
  ModalDialogContent,
  roundedLg,
  spacing5,
  textSm,
} from "@litbase/alexandria";
import { createGlobalStyle, css } from "styled-components";

export const theme = createTheme({
  primary50: "#E89C90",
  primary100: "#E48D7F",
  primary200: "#DD6E5D",
  primary300: "#D6503B",
  primary400: "#C13D28",
  primary500: "#9F3221",
  primary600: "#712317",
  primary700: "#42150E",
  primary800: "#140604",
  primary900: "#000000",
  primary1000: "#1B378A",

  secondary50: "#EAE8E9",
});

const commonScrollbarStyle = css`
  scrollbar-width: thin;

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

export const darkScrollbarStyle = css`
  ${commonScrollbarStyle};

  scrollbar-color: white transparent;

  &::-webkit-scrollbar-thumb {
    background: white;
  }
`;

export const lightScrollbarStyle = css`
  ${commonScrollbarStyle};

  scrollbar-color: #888 transparent;

  &::-webkit-scrollbar-thumb {
    background: #888;
  }
`;

export const scrollbarStylesMixin = css<{ $backgroundTone?: "light" | "dark" }>`
  ${({ $backgroundTone = "light" }) => ($backgroundTone === "dark" ? darkScrollbarStyle : lightScrollbarStyle)};
`;

export const GlobalStyle = createGlobalStyle`
  ${baseGlobalStyle};

  * {
    ${scrollbarStylesMixin};
  }
  html{
    font-size: 16px;
  }
    body {
      min-height: 100vh;
      font-family: Inter, sans-serif;
      background-color: ${({ theme }) => (theme as unknown as { gray50: string }).gray50};
    }

    input {
      outline: none !important;
    }

    h1{
      font-size: 28px;
    }
    h2,
    h3,
    h4,
    h5,
    h6 {
    }

    .tippy-content {
      font-size: ${textSm};
    }
    
    ul {
      padding-left: ${spacing5};
      color:black;
      font-size: 14px;
    }
    th, td {
      font-size: 14px;
    }
    p{
      color:black;
    }
    
    textarea {
      border: 1px solid black;
      border-radius: ${roundedLg};
    }

    ${ModalBackdrop} {
      // Notch + navbar height
      top: calc(env(safe-area-inset-top) + 4.0rem);
      height: auto;
      bottom: 0;
    }
  
    ${ModalDialogContent} {
      max-height: 85vh;
    }
`;
